<div class="resource-not-found">
  <mat-icon class="material-icons s-100">{{ icon }}</mat-icon>
  <div>
    <h1 class="mat-headline">{{ message }}</h1>
  </div>
</div>
